var staticLocation = require('../static/staticLocation')

var parseUrl = require('../url/parseUrl')

/**
  * 获取地址栏信息
  *
  * @return Object
  */
function locat () {
  return staticLocation ? parseUrl(staticLocation.href) : {}
}

module.exports = locat



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/browse/locat.js
// module id = ZD8n
// module chunks = 94